import {IDENT_AXIOS} from './backend-config';

export default {
    cities() {
        return IDENT_AXIOS.get('/cities');
    }
}
